import React from 'react';

const ScheduleHeader = ({ day }) => {
  return (
    <svg
      width="101.5%"
      height="60"
      viewBox="0 0 160 60"
      style={{ display: "block", zIndex: 0 }}
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient
          id="headerGradient"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
        >
          <stop offset="0%" stopColor="var(--light-tosca)" />
          <stop offset="100%" stopColor="var(--dark-tosca)" />
        </linearGradient>
      </defs>
      <polygon
        points="0,0 160,0 160,48 80,60 0,48"
        fill="url(#headerGradient)"
      />
      <text
        x="80"
        y="30"
        textAnchor="middle"
        fill="var(--solid-blue)"
        fontFamily="Resolve Sans, Arial, sans-serif"
        fontWeight="700"
        fontSize="24"
        letterSpacing="0.2"
        alignmentBaseline="middle"
        dominantBaseline="middle"
      >
        {day}
      </text>
    </svg>
  );
};

export default ScheduleHeader; 